export const WELCOME_FALLBACK_CODE = "W15-WELFLM26"
export const WELCOME_FALLBACK_DESCRIPTION = "Save an Extra 15%"
